import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import _paymentService from 'services/payment-services'

export function usePayMethods() {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['pay-methods',t], async () => {
        const { response } = await _paymentService.get_payMethods()
        if (response) return response
       
    })

    return { ...result, payMethods: result.data?? [] , isLoading, isError, isFetching, isSuccess,}
}


export function useCardsToken(payMethodId:any) {
    const {t} = useTranslation()

    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery(['cards',t,payMethodId], async () => {
        const { response } = await _paymentService.getCardsToken(payMethodId)
        if (response) return response
       
    })

    return { ...result, cards: result.data ?? [] , isLoading, isError, isFetching, isSuccess,}
}
